import { Navigate } from 'react-router-dom';
import { getAccessToken, hasPermission, hasOrgAccess, currentRoleLevel, captureReturnTo } from '../../services/auth';

const PrivateRoute = ({ children, module, action, scope, role }) => {
  const token = getAccessToken();
  if (!token) {
    // Stash the current path so re-login lands here. captureReturnTo reads
    // window.location directly and writes to sessionStorage — safe in render.
    //
    // We deliberately do NOT bounce on `isTokenExpired()` here. An expired
    // token still in localStorage means a refresh is either in flight or
    // about to be triggered by the next 401. Pre-emptively redirecting
    // races with the refresh: the user lands on /login a moment before
    // the new token arrives, even though the session is still valid.
    // Letting the route render lets the axios interceptor own the lifecycle
    // — it refreshes on 401 and only redirects to /login when the refresh
    // permanently fails (refresh token genuinely invalid).
    captureReturnTo();
    return <Navigate to="/login" />;
  }

  if (role) {
    const levels = { viewer: 10, member: 20, admin: 50, super_admin: 100 };
    if (currentRoleLevel() < (levels[role] || 0)) return <Navigate to="/403" />;
  }

  if (module && !hasPermission(module, action || 'read')) return <Navigate to="/403" />;

  if (scope?.orgId && !hasOrgAccess(scope.orgId)) return <Navigate to="/403" />;

  return children;
};

export default PrivateRoute;
